import { render, staticRenderFns } from "./searchButton.vue?vue&type=template&id=37a0b4a1&scoped=true"
import script from "./searchButton.vue?vue&type=script&lang=js"
export * from "./searchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_658dcddb1d89a08c03476f5e8f9c1110/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a0b4a1",
  null
  
)

export default component.exports